module.exports = __webpack_public_path__ + "static/img/logo.057314c1.svg";